import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Outlet, useParams } from 'react-router-dom';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import TargetOrgTreeContainer from '../../containers/targetmng/TargetOrgTreeContainer';

/**
 * 목표 관리 메인 페이지
 * - 좌측: 조직도 트리 + 목표 유형 선택
 * - 우측: 목표 설정 폼 (Outlet)
 */
const TargetMngPage = () => {
  const { targetTyp, deptId } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div>
      <BreadcrumbsContainer
        title="목표 관리"
        icon="goal"
      />

      <Box sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'flex-start',
        alignItems: { xs: 'stretch', sm: 'flex-start' },
        gap: 2,
        mt: 2,
        minHeight: 'calc(100vh - 200px)',
      }}>
        {/* 좌측: 조직도 트리 */}
        <Box sx={{ width: { xs: '100%', sm: '280px' }, flexShrink: 0 }}>
          <TargetOrgTreeContainer />
        </Box>

        {/* 우측: 목표 설정 폼 */}
        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
          {deptId ? (
            <Outlet />
          ) : (
            <Box
              sx={{
                p: 4,
                textAlign: 'center',
                backgroundColor: '#f5f5f5',
                borderRadius: 1,
                minHeight: 300,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography color="text.secondary" variant="h6">
                {isMobile ? '위 조직도에서 부서를 선택하세요' : '좌측 조직도에서 부서를 선택하세요'}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </div>
  );
};

export default TargetMngPage;
